import { createContext, useContext, type ReactNode } from "react"

import { Badge } from "./Badge"
import * as Icones from "./Icones"

export type Tom = "verde" | "ambar" | "vermelho" | "cinza"

type Situacao = { rotulo: string; tom: Tom; Icone: Icones.Icone; dica: string }

export const SITUACOES = {
  atrasada: { rotulo: "atrasada", tom: "vermelho", Icone: Icones.Atrasada, dica: "O prazo desta providência já passou e ela não foi concluída nem dispensada" },
  pendente: { rotulo: "pendente", tom: "ambar", Icone: Icones.Pendente, dica: "Providência ainda por fazer, com o prazo correndo" },
  concluida: { rotulo: "concluída", tom: "verde", Icone: Icones.Concluida, dica: "Alguém registrou que esta providência foi feita" },
  dispensada: { rotulo: "dispensada", tom: "cinza", Icone: Icones.Dispensada, dica: "Alguém dispensou esta providência e registrou o motivo" },

  cancelada: { rotulo: "cancelada", tom: "vermelho", Icone: Icones.Cancelada, dica: "Documento cancelado no processo do ATHUS. Continua na lista para a ordem do processo não se perder" },
  juntada: { rotulo: "juntada", tom: "cinza", Icone: Icones.Juntada, dica: "Peça que entrou no processo por juntada, depois de o processo ter sido aberto no ATHUS" },
  conferida: { rotulo: "Conferido", tom: "verde", Icone: Icones.Conferida, dica: "Alguém já abriu este documento neste sistema, e a cópia aberta ficou registrada" },
  nao_conferida: {
    rotulo: "Não Conferido",
    tom: "cinza",
    Icone: Icones.Pendente,
    dica: "Ninguém abriu este documento ainda",
  },

  validada: { rotulo: "validada", tom: "verde", Icone: Icones.Validada, dica: "Uma pessoa conferiu e confirmou, com nome e data registrados" },
  recusada: { rotulo: "recusada", tom: "vermelho", Icone: Icones.Recusada, dica: "O fiscal avaliou a peça e a recusou, com o motivo no laudo" },
  anotacao: { rotulo: "anotação", tom: "cinza", Icone: Icones.Anotacao, dica: "O fiscal registrou uma observação sobre a peça, sem aceitar nem recusar" },

  assinado: { rotulo: "assinado", tom: "verde", Icone: Icones.Laudo, dica: "O laudo foi assinado e juntado ao processo" },
  aguardando_assinatura: {
    rotulo: "aguardando assinatura qualificada",
    tom: "ambar",
    Icone: Icones.Pendente, dica: "O laudo está pronto e espera a assinatura com certificado digital que a entidade exige" },
  selo_confere: { rotulo: "o selo confere", tom: "verde", Icone: Icones.Conferida, dica: "O código de autenticidade confere com o registro deste sistema: o laudo não foi alterado" },
  selo_nao_confere: {
    rotulo: "o selo não confere",
    tom: "vermelho",
    Icone: Icones.Ressalva, dica: "O código não confere com o registro deste sistema: o documento pode ter sido alterado" },

  critico: { rotulo: "crítico", tom: "vermelho", Icone: Icones.Ressalva, dica: "O mais grave: pede providência agora" },
  atencao: { rotulo: "atenção", tom: "ambar", Icone: Icones.Ressalva, dica: "Pede cuidado em breve, antes de ficar grave" },
  informacao: { rotulo: "informação", tom: "cinza", Icone: Icones.Anotacao, dica: "Para saber, sem providência urgente" },

  nivel_a: { rotulo: "datas expressas", tom: "verde", Icone: Icones.Validada, dica: "O contrato traz escritas as datas de início e de término: não há prazo a calcular" },
  nivel_b: { rotulo: "prazo e marco expressos", tom: "verde", Icone: Icones.Validada, dica: "O contrato traz o prazo e diz de que data ele conta" },
  nivel_c: { rotulo: "regra da entidade", tom: "ambar", Icone: Icones.Ressalva, dica: "O prazo conta pela regra da entidade, com prova da data de partida. Pede conferência" },
  nivel_d: { rotulo: "data deduzida", tom: "ambar", Icone: Icones.Ressalva, dica: "A data de partida foi deduzida de uma peça do processo. Alguém precisa confirmar" },
  nivel_e: { rotulo: "indeterminado", tom: "vermelho", Icone: Icones.Recusada, dica: "Os documentos não permitem definir o prazo, ou se contradizem. Nada foi reconhecido" },

  extraida: { rotulo: "Athus", tom: "cinza", Icone: Icones.Fundamento, dica: "Lido pelo sistema num documento do processo que veio do ATHUS. Confira antes de usar em ato" },
  cadastrada: { rotulo: "cadastrada", tom: "cinza", Icone: Icones.Anotacao, dica: "Data informada no cadastro do contrato" },
  ausente: { rotulo: "ausente", tom: "ambar", Icone: Icones.Pendente, dica: "Nenhuma data deste tipo foi encontrada no contrato nem no processo" },
  declarada: { rotulo: "declarada", tom: "verde", Icone: Icones.Validada, dica: "A data que vale: declarada por quem responde pelo contrato, e é ela que conta no prazo" },

  extraido: { rotulo: "lido no documento", tom: "cinza", Icone: Icones.Anotacao, dica: "Valor lido pelo sistema num documento, ainda sem confirmação de uma pessoa" },
  calculado: { rotulo: "calculado", tom: "cinza", Icone: Icones.Recalcular, dica: "Prazo calculado pelo sistema a partir das datas encontradas, ainda sem confirmação de uma pessoa" },
  validado: { rotulo: "validado por pessoa", tom: "verde", Icone: Icones.Validada, dica: "Uma pessoa confirmou este cálculo, com nome, data e motivo registrados" },
  consolidado: { rotulo: "consolidado", tom: "verde", Icone: Icones.Conferida, dica: "O sistema reconheceu o cálculo porque os documentos o sustentam sem dúvida" },
  contestado: { rotulo: "contestado", tom: "ambar", Icone: Icones.Contestar, dica: "Uma pessoa discordou deste cálculo e registrou o motivo. Espera decisão" },
  substituido: { rotulo: "substituído", tom: "cinza", Icone: Icones.Encerrado, dica: "Cálculo antigo, trocado por um mais recente. Fica guardado no histórico" },

  vigente: { rotulo: "vigente", tom: "verde", Icone: Icones.Vigente, dica: "Situação do contrato no cadastro: em vigor. O prazo calculado aparece ao lado" },
  vencendo: { rotulo: "vencendo", tom: "ambar", Icone: Icones.Vencendo, dica: "A vigência termina em breve e pede providência de continuidade" },
  vencido: { rotulo: "vencido", tom: "vermelho", Icone: Icones.Vencido, dica: "A data de término da vigência já passou" },
  suspenso: { rotulo: "suspenso", tom: "ambar", Icone: Icones.Suspenso, dica: "A execução do contrato está suspensa" },
  encerrado: { rotulo: "encerrado", tom: "cinza", Icone: Icones.Encerrado, dica: "Contrato encerrado" },
  rescindido: { rotulo: "rescindido", tom: "vermelho", Icone: Icones.Recusada, dica: "Contrato rescindido antes do término" },

  liquidado: { rotulo: "liquidado", tom: "ambar", Icone: Icones.Anotacao, dica: "A despesa foi liquidada e ainda não foi paga" },
  pago: { rotulo: "pago", tom: "verde", Icone: Icones.Concluida, dica: "Pagamento feito" },

  aberta: { rotulo: "aberta", tom: "ambar", Icone: Icones.Pendente, dica: "Medição em andamento, ainda sem apuração" },
  apurada: { rotulo: "apurada", tom: "ambar", Icone: Icones.Anotacao, dica: "Medição apurada, esperando o ateste do fiscal" },
  atestada: { rotulo: "atestada", tom: "verde", Icone: Icones.Validada, dica: "O fiscal atestou a medição" },
  rejeitada: { rotulo: "rejeitada", tom: "vermelho", Icone: Icones.Recusada, dica: "O fiscal rejeitou a medição" },

  conferido: { rotulo: "conferido", tom: "verde", Icone: Icones.Conferida, dica: "Item conferido pelo fiscal neste mês" },
  com_ressalva: { rotulo: "com ressalva", tom: "ambar", Icone: Icones.Ressalva, dica: "Conferido, com uma ressalva registrada" },
  nao_aplicavel: {
    rotulo: "não se aplica",
    tom: "cinza",
    Icone: Icones.Dispensada, dica: "Este item não se aplica a este contrato" },
  pendente_de_conferencia: {
    rotulo: "pendente",
    tom: "vermelho",
    Icone: Icones.Pendente, dica: "Obrigação do mês ainda não conferida pelo fiscal" },

  valida: { rotulo: "válida", tom: "verde", Icone: Icones.Validada, dica: "Dentro do prazo de validade" },
  vencida: { rotulo: "vencida", tom: "vermelho", Icone: Icones.Vencido, dica: "O prazo de validade já passou" },
  sem_registro: { rotulo: "sem registro", tom: "cinza", Icone: Icones.Pendente, dica: "Nada registrado ainda" },

  confirmada: { rotulo: "confirmada", tom: "verde", Icone: Icones.Conferida, dica: "O órgão emissor confirmou o documento" },
  negada: { rotulo: "negada", tom: "vermelho", Icone: Icones.Recusada, dica: "O órgão emissor não reconheceu o documento" },
  divergente: { rotulo: "divergente", tom: "vermelho", Icone: Icones.Ressalva, dica: "O órgão emissor devolveu dados diferentes dos registrados aqui" },
  nao_configurado: {
    rotulo: "não configurado",
    tom: "cinza",
    Icone: Icones.Dispensada, dica: "Ainda não configurado neste sistema" },
  indisponivel: { rotulo: "indisponível", tom: "ambar", Icone: Icones.Suspenso, dica: "O serviço consultado não respondeu. Tente de novo mais tarde" },

  confianca_alta: { rotulo: "alta", tom: "verde", Icone: Icones.Validada, dica: "O sistema encontrou o valor numa frase clara do documento" },
  confianca_media: { rotulo: "média", tom: "ambar", Icone: Icones.Ressalva, dica: "O sistema encontrou o valor, mas a frase admite outra leitura. Confira" },
  confianca_baixa: { rotulo: "baixa", tom: "vermelho", Icone: Icones.Ressalva, dica: "O valor encontrado é duvidoso. Confira antes de usar" },
  preenchido: { rotulo: "preenchido", tom: "verde", Icone: Icones.Concluida, dica: "O sistema preencheu o campo do contrato com o que leu" },
  so_registrado: {
    rotulo: "só registrado",
    tom: "cinza",
    Icone: Icones.Anotacao, dica: "O sistema leu o valor e só o registrou, sem preencher o campo do contrato" },

  acima_do_limite: {
    rotulo: "acima do limite",
    tom: "vermelho",
    Icone: Icones.Ressalva, dica: "Os acréscimos somados passam do limite definido para o contrato" },
  dentro_do_limite: { rotulo: "dentro", tom: "verde", Icone: Icones.Validada, dica: "Os acréscimos somados estão dentro do limite" },

  senha_provisoria: {
    rotulo: "senha provisória",
    tom: "ambar",
    Icone: Icones.Chave, dica: "A senha foi criada por quem administra e precisa ser trocada na próxima entrada" },
  senha_do_dono: {
    rotulo: "trocada pelo próprio usuário",
    tom: "verde",
    Icone: Icones.Chave, dica: "A senha atual foi escolhida pelo próprio usuário" },

  ativa: { rotulo: "ativa", tom: "verde", Icone: Icones.Concluida, dica: "Em uso neste sistema" },
  inativa: { rotulo: "inativa", tom: "vermelho", Icone: Icones.Dispensada, dica: "Desativado: fica guardado, mas não está mais em uso" },
  configurado: { rotulo: "configurado", tom: "verde", Icone: Icones.Concluida, dica: "O canal está configurado e pronto para enviar avisos" },
  modalidade_a_confirmar: { rotulo: "a confirmar", tom: "ambar", Icone: Icones.Pendente, dica: "O grupo do processo no ATHUS não diz a modalidade. Quem cuida do contrato escolhe em Editar" },
  ligado: { rotulo: "configurada", tom: "verde", Icone: Icones.Concluida, dica: "A ligação está configurada neste sistema" },
  desligado: { rotulo: "não configurada", tom: "cinza", Icone: Icones.Pendente, dica: "A ligação ainda não está configurada. Peça ao setor de TI" },
  em_breve: { rotulo: "em breve", tom: "cinza", Icone: Icones.EmBreve, dica: "Esta parte do sistema ainda está sendo construída" },

  sem_fiscal: {
    rotulo: "sem fiscal designado",
    tom: "ambar",
    Icone: Icones.Pendente, dica: "Nenhum fiscal com designação vigente neste contrato" },
  vigencia_insegura: {
    rotulo: "vigência sem definição segura",
    tom: "ambar",
    Icone: Icones.Ressalva, dica: "O sistema não conseguiu definir o término com segurança. Confira as datas na aba Vigência e prazos" },
  vigencia_segura: {
    rotulo: "vigência definida",
    tom: "verde",
    Icone: Icones.Validada, dica: "O término da vigência está sustentado pelos documentos ou confirmado por uma pessoa" },
  criticidade_baixa: {
    rotulo: "criticidade baixa",
    tom: "cinza",
    Icone: Icones.Etiqueta, dica: "Contrato de criticidade baixa: atenção de rotina" },
  criticidade_media: {
    rotulo: "criticidade média",
    tom: "cinza",
    Icone: Icones.Etiqueta, dica: "Contrato de criticidade média" },
  criticidade_alta: {
    rotulo: "criticidade alta",
    tom: "ambar",
    Icone: Icones.Ressalva, dica: "Contrato de criticidade alta: pede acompanhamento mais próximo" },
  criticidade_critica: {
    rotulo: "criticidade crítica",
    tom: "vermelho",
    Icone: Icones.Ressalva, dica: "Contrato de criticidade crítica: pede o acompanhamento mais próximo" },

  papel: { rotulo: "papel", tom: "cinza", Icone: Icones.Etiqueta, dica: "O papel no processo" },
  laudo: { rotulo: "laudo", tom: "cinza", Icone: Icones.Laudo, dica: "Laudo da fiscalização produzido neste sistema e juntado ao processo" },
  origem_athus: { rotulo: "ATHUS", tom: "cinza", Icone: Icones.Etiqueta, dica: "Contrato que veio do processo no ATHUS" },
  fonte_do_arquivo: { rotulo: "arquivo", tom: "cinza", Icone: Icones.Fundamento, dica: "De onde veio o documento que está aberto" },
  origem_propria: { rotulo: "próprio", tom: "cinza", Icone: Icones.Etiqueta, dica: "Contrato cadastrado neste sistema, sem processo no ATHUS" },
  root: { rotulo: "Root", tom: "cinza", Icone: Icones.Etiqueta, dica: "Root: atende todas as entidades" },
  contagem: { rotulo: "—", tom: "cinza", Icone: Icones.Etiqueta, dica: "Situação informada pelo sistema" },
} satisfies Record<string, Situacao>

export type ChaveDeSituacao = keyof typeof SITUACOES

const SelosSemDica = createContext(false)

export function SemDicaNosSelos({ children }: { children: ReactNode }) {
  return <SelosSemDica.Provider value>{children}</SelosSemDica.Provider>
}

export function chaveDoNivel(nivel: string): ChaveDeSituacao {
  const chave = `nivel_${nivel.toLowerCase()}`
  return chave in SITUACOES ? (chave as ChaveDeSituacao) : "contagem"
}

export function chaveConhecida(
  bruta: string,
  reserva: ChaveDeSituacao = "contagem",
): ChaveDeSituacao {
  return bruta in SITUACOES ? (bruta as ChaveDeSituacao) : reserva
}

export function SeloDoValor({
  valor,
  rotulo,
  reserva = "contagem",
  titulo,
}: {
  valor: string
  rotulo?: ReactNode
  reserva?: ChaveDeSituacao
  titulo?: string
}) {
  const conhecido = valor in SITUACOES
  return (
    <Selo situacao={conhecido ? (valor as ChaveDeSituacao) : reserva} titulo={titulo}>
      {rotulo ?? (conhecido ? undefined : valor)}
    </Selo>
  )
}

export function Selo({
  situacao,
  children,
  titulo,
  classe,
  semIcone = false,
}: {
  situacao: ChaveDeSituacao
  children?: ReactNode
  titulo?: string
  classe?: string
  semIcone?: boolean
}) {
  const semDica = useContext(SelosSemDica)
  const ficha: Situacao = SITUACOES[situacao]
  const Icone = ficha.Icone
  const dica = titulo === undefined || titulo === "" ? ficha.dica : titulo
  return (
    <Badge tom={ficha.tom} title={semDica ? undefined : dica} className={classe}>
      {!semIcone && <Icone />}
      <span data-slot="selo-texto" className="min-w-0 first-letter:uppercase">{children ?? ficha.rotulo}</span>
      <span className="sr-only">. {dica}</span>
    </Badge>
  )
}
